<template>
  <div class="department-select">
    <el-popover ref="popRef" placement="bottom" trigger="click" width="240">
      <div class="department-select-content">
        <el-input
          v-model="filterValue"
          class="node-filter-input"
          clearable
          placeholder="搜索部门名称"
          :prefix-icon="Search"
          @input="nodeFilterChangeHandler"
        />

        <el-scrollbar style="height: calc(100% - 39px); margin-top: 12px">
          <el-tree
            ref="treeRef"
            check-on-click-node
            :data="departmentList"
            :default-expanded-keys="defaultExpandedKeys"
            :expand-on-click-node="false"
            :filter-node-method="filterDepartNode"
            highlight-current
            node-key="pid"
            :props="defaultProps"
            @node-click="nodeClick"
          >
            <template #default="{ node }">
              <span class="ai-depart-node-name" v-html="addNodeByWX(node.label, 1)"></span>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <template #reference>
        <div class="department-select-box" :class="{ haveValue: showText }">
          <span v-if="showText">{{ showText }}</span>
          <span v-else class="empty">请选择部门</span>
          <div class="icon">
            <i class="icon-arrow-down-s-line t-iconfont" />
            <i class="icon-close-circle-line t-iconfont" @click.stop="handleClear" />
          </div>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<script setup>
import { getDepartmentlist } from '@/api/ai-board'
import { ref, onMounted, watch } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { addNodeByWX } from '@/utils/wx-node.js'

defineOptions({
  name: 'DepartmentSelect'
})

const props = defineProps({
  value: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['update:value', 'departChange'])

const treeRef = ref(null)
const popRef = ref(null)

const defaultExpandedKeys = ref([])
const filterValue = ref('')
const defaultProps = ref({
  children: 'nodes',
  label: 'text'
})
const showText = ref('')
const departmentList = ref([])

watch(
  () => props.value,
  (val) => {
    if (!val) {
      showText.value = ''
    }
  }
)
const filterDepartNode = (value, data) => {
  if (!value) return true
  return data.text.indexOf(value) !== -1
}
const nodeFilterChangeHandler = (val) => {
  treeRef.value.filter(val)
}

// 节点点击事件
const nodeClick = (node) => {
  const { pid, text, disabled } = node
  if (disabled) return
  showText.value = text
  emits('update:value', pid)
  emits('departChange', pid)
  popRef.value.hide()
}
const handleClear = () => {
  showText.value = ''
  emits('update:value', '')
  emits('departChange', '')
}

onMounted(() => {
  getDepartmentlist({
    assistantAlias: 'meeting'
  })
    .then((res) => {
      departmentList.value = res.result.departmentTree
      defaultExpandedKeys.value = [departmentList.value[0].pid]
    })
    .catch((err) => {
      console.log(err)
    })
})
</script>

<style lang="scss" scoped>
.department-select-box {
  box-sizing: border-box;

  /* 自动布局 */
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 240px;
  height: 32px;
  padding: 6px 12px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  span {
    flex: 1;
    overflow: hidden;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .empty {
    color: #969799;
  }
  .icon {
    position: relative;
    width: 16px;
    height: 16px;

    i {
      font-size: 16px;
      color: #969799;
    }
    .icon-close-circle-line {
      display: none;
    }
  }
}
.haveValue:hover {
  .icon-close-circle-line {
    display: block;
  }
  .icon-arrow-down-s-line {
    display: none;
  }
}
</style>

<style lang="scss">
.department-select-content {
  height: 300px;
  .el-tree-node__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>

<style>
.ai-depart-node-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
